'use client';

import { useEffect, useRef, useState } from 'react';

/**
 * Tracks whether the element is in the viewport, toggling back to false once
 * it scrolls back out — so the reveal re-triggers each time it re-enters,
 * scrolling either direction.
 */
export function useInView<T extends HTMLElement>(rootMargin = '0px 0px -10% 0px') {
  const ref = useRef<T>(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting), {
      threshold: 0.15,
      rootMargin,
    });
    observer.observe(el);

    return () => observer.disconnect();
  }, [rootMargin]);

  return { ref, inView };
}
